module.exports = __webpack_public_path__ + "assets/d68bbe28256f2f0435f51a49f527f548.png";